import { DataObject, DataObjectFactory } from "@/v2/models/base-data-object.js";
import { Parameter } from "@/v2/models/parameters.js";

export class ProductGroup extends DataObject {
    _type = "product_group";

    id;
    name;
    slug;
    count;
    bo_can_delete;
    show_action_menu;
}

export class ProductGroupMapperParameter extends Parameter {
    productGroupMapper;
}

export class ProductGroupFactory {
    /**
     * Creates a new instance of a DataObject.
     * @function
     * @static
     * @param {Object, null} data Data to construct the ProductGroup object with. Also creates a product object using MetaFactory if data is not null.
     * @returns {Notification}
     */
    static construct(productGroupMapperParameter, data = null) {
        if (data != null) {
            let productGroup = DataObjectFactory.getInstance().constructWithMapper(
                ProductGroup,
                productGroupMapperParameter.productGroupMapper,
                data
            );

            return productGroup;
        }

        return null;
    }
}
